
/**
 * Export format to support Node.js scripts
 */
module.exports = { 
  gemeenten: [ 
    {code: "1680", label: "Aa en Hunze", provincie: 22, slug: "aa-en-hunze"},
    {code: "0358", label: "Aalsmeer", provincie: 27, slug: "aalsmeer"},
    {code: "0197", label: "Aalten", provincie: 25, slug: "aalten"},
    {code: "0059", label: "Achtkarspelen", provincie: 21, slug: "achtkarspelen"},
    {code: "0482", label: "Alblasserdam", provincie: 28, slug: "alblasserdam"},
    {code: "0613", label: "Albrandswaard", provincie: 28, slug: "albrandswaard"},
    {code: "0361", label: "Alkmaar", provincie: 27, slug: "alkmaar"},
    {code: "0141", label: "Almelo", provincie: 23, slug: "almelo"},
    {code: "0034", label: "Almere", provincie: 24, slug: "almere"},
    {code: "0484", label: "Alphen aan den Rijn", provincie: 28, slug: "alphen-aan-den-rijn"},
    {code: "1723", label: "Alphen-Chaam", provincie: 30, slug: "alphen-chaam"},
    {code: "1959", label: "Altena", provincie: 30, slug: "altena"},
    {code: "0060", label: "Ameland", provincie: 21, slug: "ameland"},
    {code: "0307", label: "Amersfoort", provincie: 26, slug: "amersfoort"},
    {code: "0362", label: "Amstelveen", provincie: 27, slug: "amstelveen"},
    {code: "0363", label: "Amsterdam", provincie: 27, slug: "amsterdam"},
    {code: "0200", label: "Apeldoorn", provincie: 25, slug: "apeldoorn"},
    {code: "0003", label: "Appingedam", provincie: 20, slug: "appingedam"},
    {code: "0202", label: "Arnhem", provincie: 25, slug: "arnhem"},
    {code: "0106", label: "Assen", provincie: 22, slug: "assen"},
    {code: "0743", label: "Asten", provincie: 30, slug: "asten"},
    {code: "0744", label: "Baarle-Nassau", provincie: 30, slug: "baarle-nassau"},
    {code: "0308", label: "Baarn", provincie: 26, slug: "baarn"},
    {code: "0489", label: "Barendrecht", provincie: 28, slug: "barendrecht"},
    {code: "0203", label: "Barneveld", provincie: 25, slug: "barneveld"},
    {code: "0888", label: "Beek", provincie: 31, slug: "beek"},
    {code: "1954", label: "Beekdaelen", provincie: 31, slug: "beekdaelen"},
    {code: "0370", label: "Beemster", provincie: 27, slug: "beemster"},
    {code: "0889", label: "Beesel", provincie: 31, slug: "beesel"},
    {code: "1945", label: "Berg en Dal", provincie: 25, slug: "berg-en-dal"},
    {code: "1724", label: "Bergeijk", provincie: 30, slug: "bergeijk"},
    {code: "0893", label: "Bergen (L.)", provincie: 31, slug: "bergen-limburg"},
    {code: "0373", label: "Bergen (NH.)", provincie: 27, slug: "bergen-noord-holland"},
    {code: "0748", label: "Bergen op Zoom", provincie: 30, slug: "bergen-op-zoom"},
    {code: "1859", label: "Berkelland", provincie: 25, slug: "berkelland"},
    {code: "1721", label: "Bernheze", provincie: 30, slug: "bernheze"},
    {code: "0753", label: "Best", provincie: 30, slug: "best"},
    {code: "0209", label: "Beuningen", provincie: 25, slug: "beuningen"},
    {code: "0375", label: "Beverwijk", provincie: 27, slug: "beverwijk"},
    {code: "0310", label: "De Bilt", provincie: 26, slug: "de-bilt"},
    {code: "1728", label: "Bladel", provincie: 30, slug: "bladel"},
    {code: "0376", label: "Blaricum", provincie: 27, slug: "blaricum"},
    {code: "0377", label: "Bloemendaal", provincie: 27, slug: "bloemendaal"},
    {code: "1901", label: "Bodegraven-Reeuwijk", provincie: 28, slug: "bodegraven-reeuwijk"},
    {code: "0755", label: "Boekel", provincie: 30, slug: "boekel"},
    {code: "1681", label: "Borger-Odoorn", provincie: 22, slug: "borger-odoorn"},
    {code: "0147", label: "Borne", provincie: 23, slug: "borne"},
    {code: "0654", label: "Borsele", provincie: 29, slug: "borsele"},
    {code: "0756", label: "Boxmeer", provincie: 30, slug: "boxmeer"},
    {code: "0757", label: "Boxtel", provincie: 30, slug: "boxtel"},
    {code: "0758", label: "Breda", provincie: 30, slug: "breda"},
    {code: "0501", label: "Brielle", provincie: 28, slug: "brielle"},
    {code: "1876", label: "Bronckhorst", provincie: 25, slug: "bronckhorst"},
    {code: "0213", label: "Brummen", provincie: 25, slug: "brummen"},
    {code: "0899", label: "Brunssum", provincie: 31, slug: "brunssum"},
    {code: "0312", label: "Bunnik", provincie: 26, slug: "bunnik"},
    {code: "0313", label: "Bunschoten", provincie: 26, slug: "bunschoten"},
    {code: "0214", label: "Buren", provincie: 25, slug: "buren"},
    {code: "0502", label: "Capelle aan den IJssel", provincie: 28, slug: "capelle-aan-den-ijssel"},
    {code: "0383", label: "Castricum", provincie: 27, slug: "castricum"},
    {code: "0109", label: "Coevorden", provincie: 22, slug: "coevorden"},
    {code: "1706", label: "Cranendonck", provincie: 30, slug: "cranendonck"},
    {code: "1684", label: "Cuijk", provincie: 30, slug: "cuijk"},
    {code: "0216", label: "Culemborg", provincie: 25, slug: "culemborg"},
    {code: "0148", label: "Dalfsen", provincie: 23, slug: "dalfsen"},
    {code: "1891", label: "Dantumadiel", provincie: 21, slug: "dantumadiel"},
    {code: "0503", label: "Delft", provincie: 28, slug: "delft"},
    {code: "0010", label: "Delfzijl", provincie: 20, slug: "delfzijl"},
    {code: "0762", label: "Deurne", provincie: 30, slug: "deurne"},
    {code: "0150", label: "Deventer", provincie: 23, slug: "deventer"},
    {code: "0384", label: "Diemen", provincie: 27, slug: "diemen"},
    {code: "1774", label: "Dinkelland", provincie: 23, slug: "dinkelland"},
    {code: "0221", label: "Doesburg", provincie: 25, slug: "doesburg"},
    {code: "0222", label: "Doetinchem", provincie: 25, slug: "doetinchem"},
    {code: "0766", label: "Dongen", provincie: 30, slug: "dongen"},
    {code: "0505", label: "Dordrecht", provincie: 28, slug: "dordrecht"},
    {code: "0498", label: "Drechterland", provincie: 27, slug: "drechterland"},
    {code: "1719", label: "Drimmelen", provincie: 30, slug: "drimmelen"},
    {code: "0303", label: "Dronten", provincie: 24, slug: "dronten"},
    {code: "0225", label: "Druten", provincie: 25, slug: "druten"},
    {code: "0226", label: "Duiven", provincie: 25, slug: "duiven"},
    {code: "1711", label: "Echt-Susteren", provincie: 31, slug: "echt-susteren"},
    {code: "0385", label: "Edam-Volendam", provincie: 27, slug: "edam-volendam"},
    {code: "0228", label: "Ede", provincie: 25, slug: "ede"},
    {code: "0317", label: "Eemnes", provincie: 26, slug: "eemnes"},
    {code: "0770", label: "Eersel", provincie: 30, slug: "eersel"},
    {code: "1903", label: "Eijsden-Margraten", provincie: 31, slug: "eijsden-margraten"},
    {code: "0772", label: "Eindhoven", provincie: 30, slug: "eindhoven"},
    {code: "0230", label: "Elburg", provincie: 25, slug: "elburg"},
    {code: "0114", label: "Emmen", provincie: 22, slug: "emmen"},
    {code: "0388", label: "Enkhuizen", provincie: 27, slug: "enkhuizen"},
    {code: "0153", label: "Enschede", provincie: 23, slug: "enschede"},
    {code: "0232", label: "Epe", provincie: 25, slug: "epe"},
    {code: "0233", label: "Ermelo", provincie: 25, slug: "ermelo"},
    {code: "0777", label: "Etten-Leur", provincie: 30, slug: "etten-leur"},
    {code: "1940", label: "De Fryske Marren", provincie: 21, slug: "de-fryske-marren"},
    {code: "0779", label: "Geertruidenberg", provincie: 30, slug: "geertruidenberg"},
    {code: "1771", label: "Geldrop-Mierlo", provincie: 30, slug: "geldrop-mierlo"},
    {code: "1652", label: "Gemert-Bakel", provincie: 30, slug: "gemert-bakel"},
    {code: "0907", label: "Gennep", provincie: 31, slug: "gennep"},
    {code: "0784", label: "Gilze en Rijen", provincie: 30, slug: "gilze-en-rijen"},
    {code: "1924", label: "Goeree-Overflakkee", provincie: 28, slug: "goeree-overflakkee"},
    {code: "0664", label: "Goes", provincie: 29, slug: "goes"},
    {code: "0785", label: "Goirle", provincie: 30, slug: "goirle"},
    {code: "1942", label: "Gooise Meren", provincie: 27, slug: "gooise-meren"},
    {code: "0512", label: "Gorinchem", provincie: 28, slug: "gorinchem"},
    {code: "0513", label: "Gouda", provincie: 28, slug: "gouda"},
    {code: "0786", label: "Grave", provincie: 30, slug: "grave"},
    {code: "0518", label: "'s-Gravenhage", provincie: 28, slug: "s-gravenhage"},
    {code: "0014", label: "Groningen", provincie: 20, slug: "groningen"},
    {code: "1729", label: "Gulpen-Wittem", provincie: 31, slug: "gulpen-wittem"},
    {code: "0158", label: "Haaksbergen", provincie: 23, slug: "haaksbergen"},
    {code: "0788", label: "Haaren", provincie: 30, slug: "haaren"},
    {code: "0392", label: "Haarlem", provincie: 27, slug: "haarlem"},
    {code: "0394", label: "Haarlemmermeer", provincie: 27, slug: "haarlemmermeer"},
    {code: "1655", label: "Halderberge", provincie: 30, slug: "halderberge"},
    {code: "0160", label: "Hardenberg", provincie: 23, slug: "hardenberg"},
    {code: "0243", label: "Harderwijk", provincie: 25, slug: "harderwijk"},
    {code: "0523", label: "Hardinxveld-Giessendam", provincie: 28, slug: "hardinxveld-giessendam"},
    {code: "0072", label: "Harlingen", provincie: 21, slug: "harlingen"},
    {code: "0244", label: "Hattem", provincie: 25, slug: "hattem"},
    {code: "0396", label: "Heemskerk", provincie: 27, slug: "heemskerk"},
    {code: "0397", label: "Heemstede", provincie: 27, slug: "heemstede"},
    {code: "0246", label: "Heerde", provincie: 25, slug: "heerde"},
    {code: "0074", label: "Heerenveen", provincie: 21, slug: "heerenveen"},
    {code: "0398", label: "Heerhugowaard", provincie: 27, slug: "heerhugowaard"},
    {code: "0917", label: "Heerlen", provincie: 31, slug: "heerlen"},
    {code: "1658", label: "Heeze-Leende", provincie: 30, slug: "heeze-leende"},
    {code: "0399", label: "Heiloo", provincie: 27, slug: "heiloo"},
    {code: "0400", label: "Den Helder", provincie: 27, slug: "den-helder"},
    {code: "0163", label: "Hellendoorn", provincie: 23, slug: "hellendoorn"},
    {code: "0530", label: "Hellevoetsluis", provincie: 28, slug: "hellevoetsluis"},
    {code: "0794", label: "Helmond", provincie: 30, slug: "helmond"},
    {code: "0531", label: "Hendrik-Ido-Ambacht", provincie: 28, slug: "hendrik-ido-ambacht"},
    {code: "0164", label: "Hengelo", provincie: 23, slug: "hengelo"},
    {code: "0796", label: "'s-Hertogenbosch", provincie: 30, slug: "s-hertogenbosch"},
    {code: "0252", label: "Heumen", provincie: 25, slug: "heumen"},
    {code: "0797", label: "Heusden", provincie: 30, slug: "heusden"},
    {code: "0534", label: "Hillegom", provincie: 28, slug: "hillegom"},
    {code: "0798", label: "Hilvarenbeek", provincie: 30, slug: "hilvarenbeek"},
    {code: "0402", label: "Hilversum", provincie: 27, slug: "hilversum"},
    {code: "1963", label: "Hoeksche Waard", provincie: 28, slug: "hoeksche-waard"},
    {code: "1735", label: "Hof van Twente", provincie: 23, slug: "hof-van-twente"},
    {code: "1966", label: "Het Hogeland", provincie: 20, slug: "het-hogeland"},
    {code: "1911", label: "Hollands Kroon", provincie: 27, slug: "hollands-kroon"},
    {code: "0118", label: "Hoogeveen", provincie: 22, slug: "hoogeveen"},
    {code: "0405", label: "Hoorn", provincie: 27, slug: "hoorn"},
    {code: "1507", label: "Horst aan de Maas", provincie: 31, slug: "horst-aan-de-maas"},
    {code: "0321", label: "Houten", provincie: 26, slug: "houten"},
    {code: "0406", label: "Huizen", provincie: 27, slug: "huizen"},
    {code: "0677", label: "Hulst", provincie: 29, slug: "hulst"},
    {code: "0353", label: "IJsselstein", provincie: 26, slug: "ijsselstein"},
    {code: "1884", label: "Kaag en Braassem", provincie: 28, slug: "kaag-en-braassem"},
    {code: "0166", label: "Kampen", provincie: 23, slug: "kampen"},
    {code: "0678", label: "Kapelle", provincie: 29, slug: "kapelle"},
    {code: "0537", label: "Katwijk", provincie: 28, slug: "katwijk"},
    {code: "0928", label: "Kerkrade", provincie: 31, slug: "kerkrade"},
    {code: "1598", label: "Koggenland", provincie: 27, slug: "koggenland"},
    {code: "0542", label: "Krimpen aan den IJssel", provincie: 28, slug: "krimpen-aan-den-ijssel"},
    {code: "1931", label: "Krimpenerwaard", provincie: 28, slug: "krimpenerwaard"},
    {code: "1659", label: "Laarbeek", provincie: 30, slug: "laarbeek"},
    {code: "1685", label: "Landerd", provincie: 30, slug: "landerd"},
    {code: "0882", label: "Landgraaf", provincie: 31, slug: "landgraaf"},
    {code: "0415", label: "Landsmeer", provincie: 27, slug: "landsmeer"},
    {code: "0416", label: "Langedijk", provincie: 27, slug: "langedijk"},
    {code: "1621", label: "Lansingerland", provincie: 28, slug: "lansingerland"},
    {code: "0417", label: "Laren", provincie: 27, slug: "laren"},
    {code: "0080", label: "Leeuwarden", provincie: 21, slug: "leeuwarden"},
    {code: "0546", label: "Leiden", provincie: 28, slug: "leiden"},
    {code: "0547", label: "Leiderdorp", provincie: 28, slug: "leiderdorp"},
    {code: "1916", label: "Leidschendam-Voorburg", provincie: 28, slug: "leidschendam-voorburg"},
    {code: "0995", label: "Lelystad", provincie: 24, slug: "lelystad"},
    {code: "1640", label: "Leudal", provincie: 31, slug: "leudal"},
    {code: "0327", label: "Leusden", provincie: 26, slug: "leusden"},
    {code: "1705", label: "Lingewaard", provincie: 25, slug: "lingewaard"},
    {code: "0553", label: "Lisse", provincie: 28, slug: "lisse"},
    {code: "0262", label: "Lochem", provincie: 25, slug: "lochem"},
    {code: "0809", label: "Loon op Zand", provincie: 30, slug: "loon-op-zand"},
    {code: "0331", label: "Lopik", provincie: 26, slug: "lopik"},
    {code: "0024", label: "Loppersum", provincie: 20, slug: "loppersum"},
    {code: "0168", label: "Losser", provincie: 23, slug: "losser"},
    {code: "0263", label: "Maasdriel", provincie: 25, slug: "maasdriel"},
    {code: "1641", label: "Maasgouw", provincie: 31, slug: "maasgouw"},
    {code: "0556", label: "Maassluis", provincie: 28, slug: "maassluis"},
    {code: "0935", label: "Maastricht", provincie: 31, slug: "maastricht"},
    {code: "0420", label: "Medemblik", provincie: 27, slug: "medemblik"},
    {code: "0938", label: "Meerssen", provincie: 31, slug: "meerssen"},
    {code: "1948", label: "Meierijstad", provincie: 30, slug: "meierijstad"},
    {code: "0119", label: "Meppel", provincie: 22, slug: "meppel"},
    {code: "0687", label: "Middelburg", provincie: 29, slug: "middelburg"},
    {code: "1842", label: "Midden-Delfland", provincie: 28, slug: "midden-delfland"},
    {code: "1731", label: "Midden-Drenthe", provincie: 22, slug: "midden-drenthe"},
    {code: "1952", label: "Midden-Groningen", provincie: 20, slug: "midden-groningen"},
    {code: "0815", label: "Mill en Sint Hubert", provincie: 30, slug: "mill-en-sint-hubert"},
    {code: "1709", label: "Moerdijk", provincie: 30, slug: "moerdijk"},
    {code: "1978", label: "Molenlanden", provincie: 28, slug: "molenlanden"},
    {code: "1955", label: "Montferland", provincie: 25, slug: "montferland"},
    {code: "0335", label: "Montfoort", provincie: 26, slug: "montfoort"},
    {code: "0944", label: "Mook en Middelaar", provincie: 31, slug: "mook-en-middelaar"},
    {code: "1740", label: "Neder-Betuwe", provincie: 25, slug: "neder-betuwe"},
    {code: "0946", label: "Nederweert", provincie: 31, slug: "nederweert"},
    {code: "0356", label: "Nieuwegein", provincie: 26, slug: "nieuwegein"},
    {code: "0569", label: "Nieuwkoop", provincie: 28, slug: "nieuwkoop"},
    {code: "0267", label: "Nijkerk", provincie: 25, slug: "nijkerk"},
    {code: "0268", label: "Nijmegen", provincie: 25, slug: "nijmegen"},
    {code: "1930", label: "Nissewaard", provincie: 28, slug: "nissewaard"},
    {code: "1970", label: "Noardeast-Fryslân", provincie: 21, slug: "noardeast-fryslan"},
    {code: "1695", label: "Noord-Beveland", provincie: 29, slug: "noord-beveland"},
    {code: "1699", label: "Noordenveld", provincie: 22, slug: "noordenveld"},
    {code: "0171", label: "Noordoostpolder", provincie: 24, slug: "noordoostpolder"},
    {code: "0575", label: "Noordwijk", provincie: 28, slug: "noordwijk"},
    {code: "0820", label: "Nuenen, Gerwen en Nederwetten", provincie: 30, slug: "nuenen-gerwen-en-nederwetten"},
    {code: "0302", label: "Nunspeet", provincie: 25, slug: "nunspeet"},
    {code: "0579", label: "Oegstgeest", provincie: 28, slug: "oegstgeest"},
    {code: "0823", label: "Oirschot", provincie: 30, slug: "oirschot"},
    {code: "0824", label: "Oisterwijk", provincie: 30, slug: "oisterwijk"},
    {code: "1895", label: "Oldambt", provincie: 20, slug: "oldambt"},
    {code: "0269", label: "Oldebroek", provincie: 25, slug: "oldebroek"},
    {code: "0173", label: "Oldenzaal", provincie: 23, slug: "oldenzaal"},
    {code: "1773", label: "Olst-Wijhe", provincie: 23, slug: "olst-wijhe"},
    {code: "0175", label: "Ommen", provincie: 23, slug: "ommen"},
    {code: "1586", label: "Oost Gelre", provincie: 25, slug: "oost-gelre"},
    {code: "0826", label: "Oosterhout", provincie: 30, slug: "oosterhout"},
    {code: "0085", label: "Ooststellingwerf", provincie: 21, slug: "ooststellingwerf"},
    {code: "0431", label: "Oostzaan", provincie: 27, slug: "oostzaan"},
    {code: "0432", label: "Opmeer", provincie: 27, slug: "opmeer"},
    {code: "0086", label: "Opsterland", provincie: 21, slug: "opsterland"},
    {code: "0828", label: "Oss", provincie: 30, slug: "oss"},
    {code: "1509", label: "Oude IJsselstreek", provincie: 25, slug: "oude-ijsselstreek"},
    {code: "0437", label: "Ouder-Amstel", provincie: 27, slug: "ouder-amstel"},
    {code: "0589", label: "Oudewater", provincie: 26, slug: "oudewater"},
    {code: "1734", label: "Overbetuwe", provincie: 25, slug: "overbetuwe"},
    {code: "0590", label: "Papendrecht", provincie: 28, slug: "papendrecht"},
    {code: "1894", label: "Peel en Maas", provincie: 31, slug: "peel-en-maas"},
    {code: "0765", label: "Pekela", provincie: 20, slug: "pekela"},
    {code: "1926", label: "Pijnacker-Nootdorp", provincie: 28, slug: "pijnacker-nootdorp"},
    {code: "0439", label: "Purmerend", provincie: 27, slug: "purmerend"},
    {code: "0273", label: "Putten", provincie: 25, slug: "putten"},
    {code: "0177", label: "Raalte", provincie: 23, slug: "raalte"},
    {code: "0703", label: "Reimerswaal", provincie: 29, slug: "reimerswaal"},
    {code: "0274", label: "Renkum", provincie: 25, slug: "renkum"},
    {code: "0339", label: "Renswoude", provincie: 26, slug: "renswoude"},
    {code: "1667", label: "Reusel-De Mierden", provincie: 30, slug: "reusel-de-mierden"},
    {code: "0275", label: "Rheden", provincie: 25, slug: "rheden"},
    {code: "0340", label: "Rhenen", provincie: 26, slug: "rhenen"},
    {code: "0597", label: "Ridderkerk", provincie: 28, slug: "ridderkerk"},
    {code: "1742", label: "Rijssen-Holten", provincie: 23, slug: "rijssen-holten"},
    {code: "0603", label: "Rijswijk", provincie: 28, slug: "rijswijk"},
    {code: "1669", label: "Roerdalen", provincie: 31, slug: "roerdalen"},
    {code: "0957", label: "Roermond", provincie: 31, slug: "roermond"},
    {code: "0736", label: "De Ronde Venen", provincie: 26, slug: "de-ronde-venen"},
    {code: "1674", label: "Roosendaal", provincie: 30, slug: "roosendaal"},
    {code: "0599", label: "Rotterdam", provincie: 28, slug: "rotterdam"},
    {code: "0277", label: "Rozendaal", provincie: 25, slug: "rozendaal"},
    {code: "0840", label: "Rucphen", provincie: 30, slug: "rucphen"},
    {code: "0441", label: "Schagen", provincie: 27, slug: "schagen"},
    {code: "0279", label: "Scherpenzeel", provincie: 25, slug: "scherpenzeel"},
    {code: "0606", label: "Schiedam", provincie: 28, slug: "schiedam"},
    {code: "0088", label: "Schiermonnikoog", provincie: 21, slug: "schiermonnikoog"},
    {code: "1676", label: "Schouwen-Duiveland", provincie: 29, slug: "schouwen-duiveland"},
    {code: "0965", label: "Simpelveld", provincie: 31, slug: "simpelveld"},
    {code: "1702", label: "Sint Anthonis", provincie: 30, slug: "sint-anthonis"},
    {code: "0845", label: "Sint-Michielsgestel", provincie: 30, slug: "sint-michielsgestel"},
    {code: "1883", label: "Sittard-Geleen", provincie: 31, slug: "sittard-geleen"},
    {code: "0610", label: "Sliedrecht", provincie: 28, slug: "sliedrecht"},
    {code: "1714", label: "Sluis", provincie: 29, slug: "sluis"},
    {code: "0090", label: "Smallingerland", provincie: 21, slug: "smallingerland"},
    {code: "0342", label: "Soest", provincie: 26, slug: "soest"},
    {code: "0847", label: "Someren", provincie: 30, slug: "someren"},
    {code: "0848", label: "Son en Breugel", provincie: 30, slug: "son-en-breugel"},
    {code: "0037", label: "Stadskanaal", provincie: 20, slug: "stadskanaal"},
    {code: "0180", label: "Staphorst", provincie: 23, slug: "staphorst"},
    {code: "0532", label: "Stede Broec", provincie: 27, slug: "stede-broec"},
    {code: "0851", label: "Steenbergen", provincie: 30, slug: "steenbergen"},
    {code: "1708", label: "Steenwijkerland", provincie: 23, slug: "steenwijkerland"},
    {code: "0971", label: "Stein", provincie: 31, slug: "stein"},
    {code: "1904", label: "Stichtse Vecht", provincie: 26, slug: "stichtse-vecht"},
    {code: "1900", label: "Súdwest-Fryslân", provincie: 21, slug: "sudwest-fryslan"},
    {code: "0715", label: "Terneuzen", provincie: 29, slug: "terneuzen"},
    {code: "0093", label: "Terschelling", provincie: 21, slug: "terschelling"},
    {code: "0448", label: "Texel", provincie: 27, slug: "texel"},
    {code: "1525", label: "Teylingen", provincie: 28, slug: "teylingen"},
    {code: "0716", label: "Tholen", provincie: 29, slug: "tholen"},
    {code: "0281", label: "Tiel", provincie: 25, slug: "tiel"},
    {code: "0855", label: "Tilburg", provincie: 30, slug: "tilburg"},
    {code: "0183", label: "Tubbergen", provincie: 23, slug: "tubbergen"},
    {code: "1700", label: "Twenterand", provincie: 23, slug: "twenterand"},
    {code: "1730", label: "Tynaarlo", provincie: 22, slug: "tynaarlo"},
    {code: "0737", label: "Tytsjerksteradiel", provincie: 21, slug: "tytsjerksteradiel"},
    {code: "0856", label: "Uden", provincie: 30, slug: "uden"},
    {code: "0450", label: "Uitgeest", provincie: 27, slug: "uitgeest"},
    {code: "0451", label: "Uithoorn", provincie: 27, slug: "uithoorn"},
    {code: "0184", label: "Urk", provincie: 24, slug: "urk"},
    {code: "0344", label: "Utrecht", provincie: 26, slug: "utrecht"},
    {code: "1581", label: "Utrechtse Heuvelrug", provincie: 26, slug: "utrechtse-heuvelrug"},
    {code: "0981", label: "Vaals", provincie: 31, slug: "vaals"},
    {code: "0994", label: "Valkenburg aan de Geul", provincie: 31, slug: "valkenburg-aan-de-geul"},
    {code: "0858", label: "Valkenswaard", provincie: 30, slug: "valkenswaard"},
    {code: "0047", label: "Veendam", provincie: 20, slug: "veendam"},
    {code: "0345", label: "Veenendaal", provincie: 26, slug: "veenendaal"},
    {code: "0717", label: "Veere", provincie: 29, slug: "veere"},
    {code: "0861", label: "Veldhoven", provincie: 30, slug: "veldhoven"},
    {code: "0453", label: "Velsen", provincie: 27, slug: "velsen"},
    {code: "0983", label: "Venlo", provincie: 31, slug: "venlo"},
    {code: "0984", label: "Venray", provincie: 31, slug: "venray"},
    {code: "1961", label: "Vijfheerenlanden", provincie: 26, slug: "vijfheerenlanden"},
    {code: "0622", label: "Vlaardingen", provincie: 28, slug: "vlaardingen"},
    {code: "0096", label: "Vlieland", provincie: 21, slug: "vlieland"},
    {code: "0718", label: "Vlissingen", provincie: 29, slug: "vlissingen"},
    {code: "0986", label: "Voerendaal", provincie: 31, slug: "voerendaal"},
    {code: "0626", label: "Voorschoten", provincie: 28, slug: "voorschoten"},
    {code: "0285", label: "Voorst", provincie: 25, slug: "voorst"},
    {code: "0865", label: "Vught", provincie: 30, slug: "vught"},
    {code: "1949", label: "Waadhoeke", provincie: 21, slug: "waadhoeke"},
    {code: "0866", label: "Waalre", provincie: 30, slug: "waalre"},
    {code: "0867", label: "Waalwijk", provincie: 30, slug: "waalwijk"},
    {code: "0627", label: "Waddinxveen", provincie: 28, slug: "waddinxveen"},
    {code: "0289", label: "Wageningen", provincie: 25, slug: "wageningen"},
    {code: "0629", label: "Wassenaar", provincie: 28, slug: "wassenaar"},
    {code: "0852", label: "Waterland", provincie: 27, slug: "waterland"},
    {code: "0988", label: "Weert", provincie: 31, slug: "weert"},
    {code: "0457", label: "Weesp", provincie: 27, slug: "weesp"},
    {code: "1960", label: "West Betuwe", provincie: 25, slug: "west-betuwe"},
    {code: "0668", label: "West Maas en Waal", provincie: 25, slug: "west-maas-en-waal"},
    {code: "1969", label: "Westerkwartier", provincie: 20, slug: "westerkwartier"},
    {code: "1701", label: "Westerveld", provincie: 22, slug: "westerveld"},
    {code: "0293", label: "Westervoort", provincie: 25, slug: "westervoort"},
    {code: "1950", label: "Westerwolde", provincie: 20, slug: "westerwolde"},
    {code: "1783", label: "Westland", provincie: 28, slug: "westland"},
    {code: "0098", label: "Weststellingwerf", provincie: 21, slug: "weststellingwerf"},
    {code: "0614", label: "Westvoorne", provincie: 28, slug: "westvoorne"},
    {code: "0189", label: "Wierden", provincie: 23, slug: "wierden"},
    {code: "0296", label: "Wijchen", provincie: 25, slug: "wijchen"},
    {code: "1696", label: "Wijdemeren", provincie: 27, slug: "wijdemeren"},
    {code: "0352", label: "Wijk bij Duurstede", provincie: 26, slug: "wijk-bij-duurstede"},
    {code: "0294", label: "Winterswijk", provincie: 25, slug: "winterswijk"},
    {code: "0873", label: "Woensdrecht", provincie: 30, slug: "woensdrecht"},
    {code: "0632", label: "Woerden", provincie: 26, slug: "woerden"},
    {code: "1690", label: "De Wolden", provincie: 22, slug: "de-wolden"},
    {code: "0880", label: "Wormerland", provincie: 27, slug: "wormerland"},
    {code: "0351", label: "Woudenberg", provincie: 26, slug: "woudenberg"},
    {code: "0479", label: "Zaanstad", provincie: 27, slug: "zaanstad"},
    {code: "0297", label: "Zaltbommel", provincie: 25, slug: "zaltbommel"},
    {code: "0473", label: "Zandvoort", provincie: 27, slug: "zandvoort"},
    {code: "0050", label: "Zeewolde", provincie: 24, slug: "zeewolde"},
    {code: "0355", label: "Zeist", provincie: 26, slug: "zeist"},
    {code: "0299", label: "Zevenaar", provincie: 25, slug: "zevenaar"},
    {code: "0637", label: "Zoetermeer", provincie: 28, slug: "zoetermeer"},
    {code: "0638", label: "Zoeterwoude", provincie: 28, slug: "zoeterwoude"},
    {code: "1892", label: "Zuidplas", provincie: 28, slug: "zuidplas"},
    {code: "0879", label: "Zundert", provincie: 30, slug: "zundert"},
    {code: "0301", label: "Zutphen", provincie: 25, slug: "zutphen"},
    {code: "1896", label: "Zwartewaterland", provincie: 23, slug: "zwartewaterland"},
    {code: "0642", label: "Zwijndrecht", provincie: 28, slug: "zwijndrecht"},
    {code: "0193", label: "Zwolle", provincie: 23, slug: "zwolle"},

    // Gecombineerde gemeenten
    {code: "9000", label: "CGM", provincie: 30, slug: "cgm", codeLabel: '9000 (1684, 0786, 0815)'},
    {code: "9001", label: "Friese Waddeneilanden", provincie: 21, slug: "friese-waddeneilanden", codeLabel: '9001 (0096, 0093, 0060, 0088)'},
    {code: "9002", label: "ABG", provincie: 30, slug: "abg", codeLabel: '9002 (1723, 0744, 0784)'},
    {code: "9003", label: "kempen-gemeenten", provincie: 30, slug: "kempen-gemeenten", codeLabel: '9003 (1724, 1728, 0770, 0823, 1667)'},
    {code: "9004", label: "Boxtel en Sint-Michielsgestel", provincie: 30, slug: "boxtel-en-sint-michielsgestel", codeLabel: '9004 (0757, 0845)'},
    // 9005 - 9016 = provincies
    { code: "9017", label: "BAR gemeenten", provincie: 28, slug: 'bar-gemeenten', codeLabel: '9017 (0613, 0489, 0597)' },

    // Provincies - NOTE: Proxy access also has to be defined in functions/chargingpointsload
    {code: "9005", label: "Provincie Flevoland", provincie: 24, slug: "flevoland" },
    {
      code: "9006", label: "Provincie Limburg", provincie: 31, slug: 'limburg', 
      proxy: [
        "0888", "1954", "0889", "0893", "0899", "1711", "1903", "0907", "1729", "0917", "1507", "0928", "0882", "1640", "1641", "0935", "0938", "0944", "0946", "1894", "1669", "0957", "0965", "1883", "0971", "0981", "0994", "0983", "0984", "0986", "0988", "9006"
      ]
    },
    {
      code: "9007", label: "Provincie Noord-Brabant", provincie: 30, slug: 'noord-brabant',
      proxy: [
        "1723", "1959", "0743", "0744", "1724", "0748", "1721", "0753", "1728", "0755", "0756", "0757", "0758", "1706", "1684", "0762", "0766", "1719", "0770", "0772", "0777", "0779", "1771", "1652", "0784", "0785", "0786", "0788", "1655", "1658", "0794", "0796", "0797", "0798", "1659", "1685", "0809", "1948", "0815", "1709", "0820", "0823", "0824", "0826", "0828", "1667", "1674", "0840", "1702", "0845", "0847", "0848", "0851", "0855", "0856", "0858", "0861", "0865", "0866", "0867", "0873", "0879", "9000", "9002", "9003", "9004", "9007"
      ]
    },
    {code: "9008", label: "Provincie Drenthe", provincie: 22, slug: 'drenthe' },
    {code: "9009", label: "Provincie Gelderland", provincie: 25, slug: 'gelderland' },
    {code: "9010", label: "Provincie Noord-Holland", provincie: 27, slug: 'noord-holland' },
    {code: "9011", label: "Provincie Utrecht", provincie: 26, slug: 'provincie-utrecht' },
    {code: "9012", label: "Provincie Overijssel", provincie: 23, slug: 'overijssel' },
    {code: "9013", label: "Provincie Zeeland", provincie: 29, slug: 'zeeland' },
    {code: "9014", label: "Provincie Zuid-Holland", provincie: 28, slug: 'zuid-holland' },
    {code: "9015", label: "Provincie Friesland", provincie: 21, slug: 'friesland' },
    {code: "9016", label: "Provincie Groningen", provincie: 20, slug: 'groningen' },

    // TODO: Fix uitzondering. Gent wordt: BE_44021. Nissewaard wordt: NL_1930
    {code: "gent", label: 'Gent', provincie: 0, slug: 'gent'}
  ]
}
